<div
	class="file-exports-ui-drawer"
  [class.is-expanded]="shouldBeExpanded()"
	*ngIf="shouldShowDrawer()">
	<div class="header">
		<h3>Recent Downloads</h3>
		<div class="cta-container">
      <capra-icon-button
        class="header-icon-button"
        [class.is-flipped]="expanded"
        icon="icon-chevron-up"
        size="medium"
        data-test="expand-csv-download-drawer"
        (clicked)="onExpandDrawerClick()"
      ></capra-icon-button>
      <capra-icon-button
        class="header-icon-button"
        icon="icon-close"
        size="medium"
        data-test="close-csv-download-drawer"
        (clicked)="onCloseDrawerClick()"
      ></capra-icon-button>
		</div>
	</div>
  <div class="scroll-container">
    <mode-file-exports-ui-list-item
      *ngFor="let download of downloads; trackBy: trackByFn"
      [title]="download.fileName || 'Untitled'"
      [status]="download.status"
      [id]="download.id"
      (downloadCsv)="onDownloadCsv($event)"
      (retryDownloadCsv)="onRetryDownloadCsv($event)"
      (deleteCsv)="onDeleteDownloadCsv($event)"
    ></mode-file-exports-ui-list-item>
  </div>
</div>